export default "__VITE_ASSET__D$AxFcWN__"